import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70c95b86")

_pushScopeId("data-v-70c95b86")
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-300 font-semibold" }, " Bahasa resi ", -1)
const _hoisted_3 = { class: "flex flex-grow text-14px text-gray-lp-300 uppercase" }
const _hoisted_4 = { class: "ml-4" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "border-b border-gray-lp-400" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-16px p-4" }, "Bahasa Resi")
], -1)
const _hoisted_6 = { class: "px-4 cursor-pointer" }
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_8 = { class: "text-14px font-medium text-gray-lp-300 col-span-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", {
      class: "flex items-center cursor-pointer select-none border border-gray-lp-400 rounded-md py-1 px-1 bg-white",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleListAvailableLanguage && _ctx.toggleListAvailableLanguage(...args))),
      style: {"height":"36px"}
    }, [
      _createVNode("img", {
        class: "self-center w-6 mr-3 ml-2",
        alt: _ctx.activeLocale?.flag,
        src: require(`@/app/ui/assets/svg/flag/${_ctx.activeLocale.flag}.svg`)
      }, null, 8, ["alt", "src"]),
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.activeLocale.name.toLowerCase() === "english" ? "ENG" : "INA"), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("img", {
          alt: "",
          class: "cursor-pointer select-none w-4",
          src: 
            require(`@/app/ui/assets/svg/${
              _ctx.showListAvailableLanguage
                ? 'chevron-up-new'
                : 'chevron-down-new'
            }.svg`)
          
        }, null, 8, ["src"])
      ])
    ]),
    _withDirectives(_createVNode("div", {
      class: "absolute border-l w-72 border-r flex flex-col bg-white rounded-lg shadow top-parent",
      style: _ctx.customStyleList
    }, [
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableLanguage, (language, index) => {
          return (_openBlock(), _createBlock(_Fragment, { key: index }, [
            _hoisted_7,
            _createVNode("div", {
              onClick: ($event: any) => (_ctx.changeLanguageReceipt(language.value)),
              class: "grid grid-cols-4 py-4"
            }, [
              _createVNode("img", {
                class: "self-center w-4",
                alt: language.flag,
                src: require(`@/app/ui/assets/svg/flag/${language.flag}.svg`)
              }, null, 8, ["alt", "src"]),
              _createVNode("div", _hoisted_8, _toDisplayString(language.name), 1)
            ], 8, ["onClick"])
          ], 64))
        }), 128))
      ])
    ], 4), [
      [_vShow, _ctx.showListAvailableLanguage]
    ])
  ], 512)), [
    [_directive_click_outside, _ctx.forceCloseListAvailableLanguage]
  ])
})